import styled from "styled-components";
interface ITd {
  isOdd: boolean;
  isFirst: boolean;
  isLast: boolean;
}
export const Table = styled.table`
  width: 100%;
  font-size: 0.75rem;
`;

export const Th = styled.th`
  text-align: center;
  font-weight: 500;
  color: #123559;
`;
export const Thead = styled.thead`
  border-bottom: 2px solid #777;
`;

export const Tbody = styled.tbody`
  overflow: scroll;
`;

export const TrBody = styled.tr`
  padding: 1rem;
  margin: 1rem 0;
  border-radius: 1rem;
  overflow: hidden;
`;

export const Td = styled.td`
  background-color: #fff;
  padding: 0.5rem 1rem;
  ${(props: ITd) => props.isOdd && "background-color: #E1EEFB;"}
  ${(props: ITd) => props.isFirst && "border-radius: 1rem 0 0 1rem;"}
  ${(props: ITd) => props.isLast && "border-radius: 0 1rem 1rem 0;"}
`;

export const ContainerIndexTable = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
  color: #123559;
  align-items: center;
`;

interface IButtomIndexProps {
  isActive: boolean;
}

export const ButtomIndex = styled.button`
  border: none;
  padding: 0 0.5rem;
  margin: 0;
  height: fit-content;
  background-color: transparent;
  color: #123559;
  ${(props: IButtomIndexProps) => props.isActive && "font-weight: 1000;"}
`;
